import { createSlice } from '@reduxjs/toolkit';
import { Paginated } from '../../services/api-handlers/pagination';
import { Nullable, QuizQuestion } from '../../types';
import { takeOne } from '../../helpers/store';
import { listQuizQuestions, updateQuizAnswer, updateQuizQuestion } from '../thunks/quiz-thunks';
import { ReducerState } from '../configure-store';

export interface QuizState extends ReducerState {
    data: Paginated<QuizQuestion>;
    current: Nullable<QuizQuestion>;
}

const initialState: QuizState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'quiz',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listQuizQuestions.pending, takeOne.pendingActionCase)
            .addCase(listQuizQuestions.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listQuizQuestions.rejected, takeOne.rejectedActionCase)

            .addCase(updateQuizQuestion.pending, takeOne.pendingActionCase)
            .addCase(updateQuizQuestion.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateQuizQuestion.rejected, takeOne.rejectedActionCase)

            .addCase(updateQuizAnswer.pending, takeOne.pendingActionCase)
            .addCase(updateQuizAnswer.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateQuizAnswer.rejected, takeOne.rejectedActionCase);
    },
});

export const {} = slice.actions;

export default slice.reducer;
